import db from '../../js/db'
import * as types from '../mutations-types'
import { firestoreAction, vuexfireMutations } from 'vuexfire'

const state = {
  selected: 0,
  all: {},
}

// getters
const getters = {
  my_squadra: (state, getters, rootState, rootGetters) => getMySquadra(state, getters, rootState, rootGetters),
  selected_squadra: state => state.selected,
}

function getMySquadra(state, getters, rootState, rootGetters) {
  const user_uid = rootState.user.user_uid;
  const asta_squadre = rootGetters.asta_squadre;
  if (!user_uid) {
    return null;
  } else if (asta_squadre[user_uid]) {
    return asta_squadre[user_uid]
  } else {
    return null;
  }
}

// actions
const actions = {
  setSquadre({
    commit
  }) {
    return db.getSquadre()
      .then(
        (squadre) => {
          // console.log('setSquadre', squadre)
          commit(types.SQUADRE_SET, squadre)
        }
      )
  },
  setSquadraSelected({ commit, state }, id) {
    commit(types.SQUADRE_SEL, id)
  },
  fetchSquadre() {
    db.fetchSquadre()
  }
}

// mutations
const mutations = {
  [types.SQUADRE_SET](state, squadre) {
    if(squadre){
      state.all = squadre;
    }else{
      state.all = {}; // altrimenti esce null e da errore quando nn ci sn squadre iscritte ancora (importante per le divisioni)
    }
  },
  [types.SQUADRE_SEL](state, squadra) {
    state.selected = squadra;
  },
  [types.SQUADRE_CLR](state) {
    state.all = {};
    state.selected = null;
  },
  ...vuexfireMutations
}

export default {
  state,
  getters,
  actions,
  mutations
}